import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { emailRegex, onlyNames, popularDomains } from '@/utils';
import stringSimilarity from 'string-similarity'; // Ensure it's installed

export const FormikConfig: any = (handleSubmit: any) => {
  const { t } = useTranslation();

  return useFormik({
    initialValues: {
      name: '',
      lastname: '',
      phonenumber: '',
      description: '',
      referralCode: '',
      email: '',
      password: '',
      confirm_password: '',
      is13OrOlder: false,
      acceptedTerms: false,
    },

    validationSchema: Yup.object({
      name: Yup.string()
        .required(t('field_required'))
        .min(3, t('min_invalid', { number: 3 }))
        .max(40, t('max_invalid', { number: 40 }))
        .matches(onlyNames, t('only_letters')),

      lastname: Yup.string()
        .required(t('field_required'))
        .min(3, t('min_invalid', { number: 3 }))
        .max(60, t('max_invalid', { number: 60 }))
        .matches(onlyNames, t('only_letters')),

      email: Yup.string()
        .required(t('field_required'))
        .matches(emailRegex, t('invalid_email'))
        .test('check-domain', (value, context) => {
          if (value) {
            const domain = value.split('@')[1];
            if (domain) {
              const bestMatch = stringSimilarity.findBestMatch(domain, popularDomains);
              if (bestMatch.bestMatch.rating > 0.7 && bestMatch.bestMatch.target !== domain) {
                return context.createError({
                  message: t('did_you_mean', {
                    suggestion: `${value.split('@')[0]}@${bestMatch.bestMatch.target}`,
                  }),
                });
              }
            }
          }
          return true;
        }),

      password: Yup.string()
        .required(t('field_required'))
        .min(10, t('min_invalid', { number: 10 })),

      confirm_password: Yup.string()
        .required(t('field_required'))
        .oneOf([Yup.ref('password')], t('password_must_match')),

      phonenumber: Yup.string().notRequired(),
      description: Yup.string().max(255, t('max_invalid', { number: 255 })),
      referralCode: Yup.string().notRequired(),

      is13OrOlder: Yup.bool()
        .oneOf([true], t('field_required')),

      acceptedTerms: Yup.bool()
        .oneOf([true], t('field_required')),
    }),

    validateOnChange: true,
    validateOnBlur: true,

    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
};
